/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{margin-left:auto;color:#0080ff;font-size:16px;font-weight:600;display:-webkit-inline-box;display:inline-flex;gap:16px}.thumb[_ngcontent-%COMP%]{cursor:pointer}.active[_ngcontent-%COMP%]{color:#0080ff}.inactive[_ngcontent-%COMP%]{color:#d3d3d3}.disabled[_ngcontent-%COMP%]{cursor:not-allowed}"];
export { styles as styles };
//# sourceMappingURL=liveclass-survey-selector.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/teacher-feedback/teacher-liveclass-feedback-modal/liveclass-survey/liveclass-survey-selector/liveclass-survey-selector.component.scss.shim.ngstyle.js
// module id = 1307
// module chunks = 26 27 28